const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 3600;
const SECONDS_PER_DAY = 86400;

const LABEL_STARTS_IN = "Starts in";
const LABEL_OPENS_IN = "Opens in";
const LABEL_OPEN_EARLY = "Starting soon";
const LABEL_LIVE = "Live";
const LABEL_ENDED = "This event has ended";
const LABEL_UNSCHEDULED = "Start time to be announced";

const pad = value => String(value).padStart(2, "0");

function countdownSegments(secondsRemaining) {
  const total = Math.max(0, Math.floor(Number(secondsRemaining) || 0));
  const days = Math.floor(total / SECONDS_PER_DAY);
  const hours = Math.floor(total % SECONDS_PER_DAY / SECONDS_PER_HOUR);
  const minutes = Math.floor(total % SECONDS_PER_HOUR / SECONDS_PER_MINUTE);
  const seconds = total % SECONDS_PER_MINUTE;

  return {
    days,
    hours: pad(hours),
    minutes: pad(minutes),
    seconds: pad(seconds),
  };
}

function startTimestamp(entity) {
  const candidates = [entity?.startTime, entity?.startTimestamp, entity?.start_timestamp];
  const found = candidates.map(value => Number(value || 0)).find(value => Number.isFinite(value) && value > 0);

  return found || 0;
}

function completedAt(entity) {
  return Number(entity?.completedAt || entity?.completed_at || 0);
}

function describeCountdownState({ entity, now, secondsUntilStart, secondsUntilEarlyAccess, hasEarlyAccessWindow }) {
  const start = startTimestamp(entity);
  if (completedAt(entity) > 0) {
    return { isCounting: false, label: LABEL_ENDED, settledCopy: "Thanks for coming.", secondsRemaining: 0 };
  }
  if (start <= 0) {
    return { isCounting: false, label: LABEL_UNSCHEDULED, settledCopy: "Check back soon.", secondsRemaining: 0 };
  }
  if (secondsUntilStart <= 0 || now >= start) {
    return { isCounting: false, label: LABEL_LIVE, settledCopy: "The event has started.", secondsRemaining: 0 };
  }
  if (hasEarlyAccessWindow && secondsUntilEarlyAccess <= 0) {
    return { isCounting: true, label: LABEL_OPEN_EARLY, settledCopy: "", secondsRemaining: secondsUntilStart };
  }
  if (hasEarlyAccessWindow) {
    return { isCounting: true, label: LABEL_OPENS_IN, settledCopy: "", secondsRemaining: secondsUntilEarlyAccess };
  }

  return { isCounting: true, label: LABEL_STARTS_IN, settledCopy: "", secondsRemaining: secondsUntilStart };
}

module.exports = {
  countdownSegments,
  describeCountdownState,
  LABEL_STARTS_IN,
  LABEL_OPENS_IN,
  LABEL_OPEN_EARLY,
  LABEL_LIVE,
  LABEL_ENDED,
  LABEL_UNSCHEDULED,
};
